import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  contentDetails: {},
  pagination: {}
};

const EmailTemplateListSlice = createSlice({
  name: 'emailTemplates',
  initialState: initialState,
  reducers: {
    addEmailTemplateData(state, action) {
      const { data, pagination } = action.payload;
      return { data, pagination, isTemplateDeleted: false, isUpdated: false, isAdded: false };
    },
    editEmailTemplateDetails(state, action) {
      const { TemplateDetails, fieldDetails } = action.payload;
      return { ...state, contentDetails: TemplateDetails, fieldDetails };
    },
    deleteTemplate(state) {
      return { ...state, isTemplateDeleted: true };
    },
    updateData(state) {
      return { ...state, isUpdated: true, isAdded: true };
    }
  }
});

export const { addEmailTemplateData, editEmailTemplateDetails, deleteTemplate, updateData } =
  EmailTemplateListSlice.actions;
export default EmailTemplateListSlice.reducer;
